export { Autoplay, AutoScroll, useEmblaCarousel } from './carousel';
export { clsx, type ClassValue } from './clsx';
export {
  default as Cookies,
  Cookies as CookiesLib,
  type CookieAttributes,
} from './cookies';
export { Dayjs, dayjs, duration } from './dayjs';
export { parse, type HTMLReactParserOptions } from './htmlReactParser';
export { Lottie } from './lottie';

export { io, Socket } from './socketIo';

export {
  animate,
  AnimatePresence,
  LayoutGroup,
  LazyMotion,
  motion,
  Reorder,
  useMotionTemplate,
  useSpring,
  useTransform,
  useVelocity,
  type AnimationPlaybackControls,
  type Variants,
} from './motion';

export { toPng } from 'html-to-image';
export { AppProgressProvider, useProgress, useProgressRouter } from './progressbar';
export {
  AudioPlayerProvider,
  useAudioPlayer,
  type AudioPlayer,
} from './reactAudioPlayer';

export {
  Controller,
  type ControllerProps,
  FormProvider,
  useController,
  useForm,
  useFormState,
  useWatch,
  zodResolver,
  type Control,
  type FieldError,
  type FieldErrors,
  type UseFormHandleSubmit,
  type UseFormRegister,
  type UseFormRegisterReturn,
  type UseFormReset,
  type UseFormReturn,
  type UseFormTrigger,
} from './reactHookForm';

export { cepPromise, searchCep, type CepPromiseResponse } from './cepPromise';
export { QRCode } from './reactQrCode';
export { cn, tv } from './shadcnUtils';
export { toast, Toaster } from './toast';
export { DrawerPrimitive } from './vaul';
export { z } from './zod';
export { create, createJSONStorage, devtools, persist } from './zustand';
